export default [
  { label: 'Keine Zeit', absageStatus: 'keine Zeit' },
  { label: 'Kein Interesse', absageStatus: 'kein Interesse' },
  { label: 'Anderer Grund', freeText: true, absageStatus: 'Absage' },
];
